import {marineHubAPI, RestQueryParams} from 'marine-panel-common-web';
import {Observable} from 'rxjs';

export function bindArticleToMarinasAPI(authToken: string | null, articleId: string, marinaId: string[]): Observable<any> {
    const headers = {
            Authorization: `Bearer ${authToken}`,
        },
        payload = {
            ids: marinaId,
        };

    return marineHubAPI.put(`api/articles/${articleId}/bind_to_marinas`, payload, new RestQueryParams(), headers);
}
